module.exports = __webpack_public_path__ + "img/br.b651ba94.png";